import styled from 'styled-components';

export const Container = styled.div<{
  $hasLowHeight: boolean;
  $height?: number;
}>`
  position: relative;
  height: ${({ $height, $hasLowHeight }) =>
    $height ? `${$height}px` : $hasLowHeight ? '14.2rem' : '17.2rem'};
  overflow: hidden;
`;
